import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Loader from "../child/Loder";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import { fetchSubscriptionById } from "../services/PaymentsandTransactions";
import moment from "moment";

const SubscriptionsViewPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [subscription, setSubscription] = useState(null);
    const [loading, setLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [activeTab, setActiveTab] = useState("subscription-info");


    const getSubscriptionDetails = async () => {
        try {
            const res = await fetchSubscriptionById(id);
            setSubscription(res?.data?.data);
        } catch (error) {
            console.error(error);
            setErrorMessage("Failed to load subscription details");
            setTimeout(() => setErrorMessage(""), 3000);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            getSubscriptionDetails();
        }
    }, [id]);

    if (loading) return <Loader />;

    return (
        <div className="row gy-4">
            <div className="col-md-12">
                <div className="card h-100">
                    <div className="card-body p-24">

                        {/* Alerts */}
                        {successMessage && (
                            <SuccessAlert
                                message={successMessage}
                                onClose={() => setSuccessMessage("")}
                            />
                        )}
                        {errorMessage && (
                            <DengerAlert
                                message={errorMessage}
                                onClose={() => setErrorMessage("")}
                            />
                        )}

                        {/* Tabs */}
                        <ul
                            className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link d-flex align-items-center px-24 ${activeTab === "subscription-info" ? "active" : ""
                                        }`}
                                    onClick={() => setActiveTab("subscription-info")}
                                    type="button"
                                    role="tab"
                                >
                                    Subscription Info
                                </button>
                            </li>
                        </ul>

                        <div className="tab-content">
                            <div
                                className={`tab-pane fade ${activeTab === "subscription-info" ? "show active" : ""
                                    }`}
                                role="tabpanel"
                            >
                                {/* Details Grid */}
                                <div className="row">

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">User Name:</label>
                                        <div>{subscription?.userId?.fullName || "N/A"}</div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">User Email:</label>
                                        <div>{subscription?.userId?.email || "N/A"}</div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Platform:</label>
                                        <div>{subscription?.platform || "N/A"}</div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Product ID:</label>
                                        <div>{subscription?.productId || "N/A"}</div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Product:</label>
                                        <div>
                                            {subscription?.productId === "curiouzz_club_trial"
                                                ? "Curiouzz Club – Free Trial"
                                                : subscription?.productId}
                                        </div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Subscription Type:</label>
                                        <div>{subscription?.isTrial ? "Free Trial" : "Paid"}</div>
                                    </div>


                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Status:</label>
                                        <div>{subscription?.status || "N/A"}</div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Auto Renew:</label>
                                        <div>{subscription?.autoRenew ? "Yes" : "No"}</div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Environment:</label>
                                        <div>{subscription?.environment || "N/A"}</div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Start Date:</label>
                                        <div>
                                            {subscription?.startDate
                                                ? moment(subscription.startDate).format("DD-MM-YYYY, hh:mm A")
                                                : "N/A"}
                                        </div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Expiry Date:</label>
                                        <div>
                                            {subscription?.expiryDate
                                                ? moment(subscription.expiryDate).format("DD-MM-YYYY, hh:mm A")
                                                : "N/A"}
                                        </div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Updated At:</label>
                                        <div>
                                            {subscription?.updatedAt
                                                ? moment(subscription.updatedAt).format("DD-MM-YYYY, hh:mm A")
                                                : "N/A"}
                                        </div>
                                    </div>


                                    {subscription?.isTrial && (
                                        <>

                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label fw-bold">Granted By:</label>
                                                    <div>
                                                        {subscription?.trialMeta?.grantedBy?.email || "System / Admin"}
                                                    </div>
                                                </div>

                                                {subscription?.trialMeta?.reason && (
                                                    <div className="col-md-8 mb-3">
                                                        <label className="form-label fw-bold">Reason:</label>
                                                        <div>{subscription.trialMeta.reason}</div>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionsViewPage;
